module.exports = __webpack_public_path__ + "5aa7e633aba09039ac2189e42f8166b2.svg";